module.exports = __webpack_public_path__ + "static/media/area_social_media_addon.283eea98.jpg";